import { DatePicker, Form, Input, Select, Space } from 'antd';
import styles from '../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAllUsers } from 'pages/Tasks/redux/slice';
import {
  createFollowUp,
  selectFollowUpSlice
} from 'pages/FollowUp/redux/slice';
import { getFormattedDateToSend, getLoggedInUser } from 'utilities/helpers';

/** Reusable follow-up form content (no modal). Use inside FloatingActionButton or standalone with CustomModal. */
export function FollowUpFormContent({ onClose }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading } = useSelector(selectFollowUpSlice);
  const [team, setTeam] = useState([]);
  const { user_details } = getLoggedInUser();

  const handleClose = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    dispatch(getAllUsers()).then((res) => {
      if (res?.payload?.success) {
        setTeam(res.payload.data || []);
      }
    });

    form.setFieldsValue({
      assigned_to: user_details?.id
    });
  }, []);

  const onFinish = (values) => {
    const payload = {
      ...values,
      followup_date: getFormattedDateToSend(values.followup_date)
    };

    dispatch(createFollowUp(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
      }
    });
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
        Create follow-up
      </h3>

      <div className="!mt-4 flex flex-col gap-2">
        <FormItem
          label="What to follow up on?"
          name="title"
          rules={[{ required: true, message: 'Title is required' }]}
          className={styles.customLable}
        >
          <Input placeholder="Enter follow-up title" />
        </FormItem>

        <FormItem
          label="With whom?"
          name="with_whom"
          rules={[{ required: true, message: 'This is required' }]}
          className={styles.customLable}
        >
          <Input placeholder="Enter name" />
        </FormItem>

        <FormItem
          label="Who should follow up?"
          name="assigned_to"
          rules={[{ required: true, message: 'User is required' }]}
          className={styles.customLable}
        >
          <Select
            showSearch
            optionFilterProp="children"
            style={{ width: '100%' }}
            className={styles.selectField}
          >
            {team.map((item) => (
              <Select.Option value={item.id} key={item.id}>
                {item.first_name} {item.last_name}
              </Select.Option>
            ))}
          </Select>
        </FormItem>

        <FormItem
          label="Follow-up date"
          name="followup_date"
          rules={[{ required: true, message: 'Follow-up date is required' }]}
          className={styles.customLable}
        >
          <DatePicker style={{ width: '100%' }} placeholder="Select date" />
        </FormItem>

        <FormItem
          label="Notes"
          name="followup_notes"
          className={styles.customLable}
        >
          <Input.TextArea rows={3} placeholder="Add any additional context" />
        </FormItem>
      </div>

      <FormItem className="text-center">
        <Space style={{ marginTop: '20px' }}>
          <CustomButton
            className={styles.inwardButton}
            onClick={handleClose}
            type="primary"
            ghost
          >
            Cancel
          </CustomButton>
          <CustomButton
            className={styles.inwardButton}
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Create Follow-up
          </CustomButton>
        </Space>
      </FormItem>
    </Form>
  );
}

export default function ToggleFollow({ onClose }) {
  return (
    <CustomModal
      visible={true}
      footer={null}
      className={`!w-full sm:!w-[60%] md:!w-[45%] lg:!w-[40%] xl:!w-[35%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <FollowUpFormContent onClose={onClose} />
    </CustomModal>
  );
}
